import ScoringMenuButton from './ScoringMenuButton'

export default ScoringMenuButton
